import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { useActionState } from "../../../context/ActionProvider/action-state";
import { useActionReducer } from "../../../context/ActionProvider";
import RiotBarLoader, { useAuthState } from "@riotgames/riotbar-react";
import { z } from "zod";
import { Lightbox } from "../../../components/Lightbox";
import { BladeCommonSchema } from "../../../types";
import { Blade } from "../../../components/Blade";
import { RsoModal, RsoModalSchema } from "./RsoModal";
import { useRegistrationEvents } from "@riotgames/gtm-tracker-rg-web";
import { SessionStorageProvider } from "@riotgames/browserstorage-rg-web";
const RiotBarBladeSchema = BladeCommonSchema.extend({
    productId: z.string(),
    locale: z.string(),
    environment: z.string(),
    rsoModal: RsoModalSchema.optional(),
});
export const RiotBarContractSchema = RiotBarBladeSchema.extend({ type: z.literal("riotbar") });
export const _RiotBar = ({ productId, locale, environment, rsoModal }) => {
    const { showModal, modalType, protectedUrl } = useActionState();
    const { isAuthenticated, sub: puuid } = useAuthState();
    const { dispatchAction } = useActionReducer();
    const { isRegistrationInProgress, trackRegistrationConfirmation } = useRegistrationEvents({});
    useEffect(() => {
        if (puuid && isRegistrationInProgress()) {
            trackRegistrationConfirmation({ data: { puuid } });
        }
    }, [isRegistrationInProgress, puuid, trackRegistrationConfirmation]);
    useEffect(() => {
        if (showModal && (isAuthenticated || window.location.hostname === "local.playvalorant.com") && protectedUrl) {
            window.location.href = protectedUrl;
        }
    }, [isAuthenticated, protectedUrl, showModal]);
    const handleBarLoaded = useCallback(() => {
        window.RiotBar.account.openModal = () => {
            dispatchAction({ type: "show_rso_modal" });
        };
    }, [dispatchAction]);
    return (React.createElement(Blade, { "data-testid": "RiotBar" },
        React.createElement(RiotBarLoader, { locale: locale, product: productId, environment: environment, onLoad: handleBarLoaded }),
        !isAuthenticated && rsoModal && (React.createElement(Lightbox, { visible: showModal, onChange: (visible) => visible || dispatchAction({ type: "close_modal" }) }, modalType === "login" ? React.createElement(RsoModal, { ...rsoModal, protectedUrl: protectedUrl, locale: locale }) : null))));
};
const WrappedRiotBar = (props) => (React.createElement(SessionStorageProvider, null,
    React.createElement(_RiotBar, { ...props })));
export const RiotBar = styled(WrappedRiotBar) ``;
//# sourceMappingURL=RiotBar.js.map